import { motion } from "framer-motion";
import { scrollToId } from "@/App";

const PIECES = [
  "Luxury Abayas — crepe, nida & satin finishes",
  "Emirati & Saudi Thobes — Japanese high-density weaves",
  "Jalabiyas & Sheilas — seasonal embroidery lines",
  "Bisht with golden trims — ceremonial & gifting",
];

export default function ArabicWear() {
  return (
    <section id="arabic" data-testid="arabic-wear-section" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-16 bg-[#12141B]">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6 order-2 lg:order-1"
        >
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#D4AF37]/80 mb-4">Arabic Wear Wholesale</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-snug">
            Authentic GCC apparel, <span className="italic text-gold-gradient">engineered for desert climates.</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg font-light leading-relaxed text-slate-300 max-w-xl">
            Our Arabic wear program is built on breathable Japanese poly-cotton weaves and premium nida fabrics —
            cool to the touch, colourfast through repeated washing, and cut to true regional sizing.
          </p>
          <ul className="mt-10 space-y-4">
            {PIECES.map((p, i) => (
              <motion.li
                key={p}
                initial={{ opacity: 0, x: -24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`arabic-item-${i + 1}`}
                className="flex items-start gap-4"
              >
                <span className="mt-2 w-6 h-px bg-[#D4AF37]" />
                <span className="text-base sm:text-lg font-light text-slate-200">{p}</span>
              </motion.li>
            ))}
          </ul>
          <button
            data-testid="arabic-rfq-button"
            onClick={() => scrollToId("#contact")}
            className="mt-10 px-8 py-4 bg-[#D4AF37] text-[#0A0B0E] text-xs font-semibold tracking-[0.22em] uppercase hover:bg-[#E5C158] transition-colors duration-300"
          >
            Request Arabic Wear Catalog
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-6 order-1 lg:order-2 grid grid-cols-2 gap-4"
        >
          <img
            src="https://images.unsplash.com/photo-1645865675130-12f815af759e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
            alt="Luxury abaya"
            className="w-full h-[300px] lg:h-[380px] object-cover border border-[#D4AF37]/25 mt-10 hover:scale-[1.03] transition-transform duration-700"
          />
          <img
            src="https://images.unsplash.com/photo-1652784549134-bae822a7c4a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
            alt="Traditional thobe"
            className="w-full h-[300px] lg:h-[380px] object-cover border border-[#D4AF37]/25 hover:scale-[1.03] transition-transform duration-700"
          />
        </motion.div>
      </div>
    </section>
  );
}
